import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const TutorialContext = createContext({ active: false, startTutorial: () => {}, stopTutorial: () => {} });

export function TutorialProvider({ children }) {
  const [active, setActive] = useState(false);
  useEffect(() => {
    window.__worldTravelerTutorialActive = active;
    return () => { delete window.__worldTravelerTutorialActive; };
  }, [active]);
  const value = useMemo(() => ({
    active,
    startTutorial: () => setActive(true),
    stopTutorial: () => setActive(false),
  }), [active]);
  return <TutorialContext.Provider value={value}>{children}</TutorialContext.Provider>;
}

export function useTutorial() {
  return useContext(TutorialContext);
}
